<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.WarmReminder')"
    width="520px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="confirm-text" style="margin: 20px 0 15px 60px;">
      {{ $t('CargoMsg.Cargo_ConfirmReturnResubmit') }}
    </div>
    <el-form label-position="left" label-width="100px" style="margin: 0 0 20px 60px;">
      <el-form-item :label="$t('CargoMsg.Cargo_ReturnModuleSelection')">
        <el-select
          v-model="returnType"
          :placeholder="$t('common.placeholder.select')"
          style="width: 300px;"
          class="full-width"
        >
          <el-option
            v-for="item in moduleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ReturnReason')">
        <el-input
          v-model="returnRemark"
          type="textarea"
          :rows="3"
          style="width: 300px;"
          class="full-width"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="btnConfirm">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { batchReturnPreApproval } from '@/api/booking/job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import $store from '@/store'
import { OPERATING } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'JobReturnReviewDialog',
  components: { cargoAdvanceSelect },
  props: {
    lob: { type: String, required: false },
    visible: { type: Boolean, required: true },
    selectedJobs: { type: Array, required: true },
    srouce: { type: String, required: true }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      innerVisible: false,
      returnRemark: '',
      returnType: 1,
      toExoSystemHc: false,
      moduleOptions: []
    }
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        this.initConfig()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.toExoSystemHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.returnRemark = ''
      this.returnType = 1
      this.moduleOptions = []
      // 出口业务与综合物流为订舱预审，进口业务为预报
      if (this.lob === SystemConstants.SI.code || this.lob === SystemConstants.AI.code) {
        this.moduleOptions.push({ value: 1, label: this.$t('CargoMsg.Cargo_Prediction') })
      } else {
        this.moduleOptions.push({ value: 1, label: this.$t('CargoMsg.Cargo_BookingPreAudit') })
      }
      // 非出口业务与综合物流没有远程订舱
      if (this.lob === SystemConstants.SE.code || this.lob === SystemConstants.AE.code || this.lob === SystemConstants.RE.code || this.lob === SystemConstants.RI.code) {
        this.moduleOptions.push({ value: 2, label: this.$t('CargoMsg.Cargo_RemoteBooking') })
      }
    },
    async btnConfirm() {
      if (!this.selectedJobs || this.selectedJobs.length === 0) {
        return
      }
      // this.selectedJobs = this.selectedJobs.filter(item => item.jobState === SystemConstants.OPERATING)
      // 远程订舱仅支持出口业务退回
      if (this.returnType === 2 && (this.lob !== SystemConstants.SE.code && this.lob !== SystemConstants.AE.code && this.lob !== SystemConstants.RE.code && this.lob !== SystemConstants.RI.code)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemoteBookingExportOnly'))
        return
      }
      if (this.toExoSystemHc) {
        if (this.returnType === 1 && (this.lob === SystemConstants.SE.code || this.lob === SystemConstants.AE.code)) {
          const fobJob = this.selectedJobs.find(item => item.incoTerm === 'FOB')
          if (fobJob) {
            this.$message.warning(this.$t('CargoMsg.Cargo_FOBReturnRestriction'))
            return
          }
        }
      }
      const selectJobUuids = Array.from(this.selectedJobs, p => p.uuid)
      const params = {
        jobUuids: selectJobUuids,
        branchId: this.$store.getters.currentOfficeId,
        returnType: this.returnType,
        returnRemark: this.returnRemark,
        lob: this.lob
      }
      const loading = getLoading4Cxt(this)
      batchReturnPreApproval(params).then(res => {
        if (res.data) {
          this.confirmResult(res.data)
        }
      }).finally(() => {
        loading.close()
      })
    },
    confirmResult(result) {
      const msgArray = []
      if (!result) {
        return
      }
      if (result.successCount || result.successCount === 0) {
        const count = Number(result.successCount)
        msgArray.push(this.$t('CargoMsg.Cargo_ReturnResult', [count, this.selectedJobs.length - count]))
      }
      if (result.masterJobNos && result.masterJobNos.length > 0) {
        const masterJobNos = result.masterJobNos.join(',')
        if (this.srouce === 'detail') {
          msgArray.push(this.$t('CargoMsg.Cargo_MasterTicketRelationError'))
        } else {
          msgArray.push(this.$t('CargoMsg.Cargo_MasterTicketRelationAlert', [masterJobNos]))
        }
      }
      if (result.errorSources && result.errorSources.length > 0) {
        const errorSources = result.errorSources.join(',')
        if (this.returnType === 1) {
          msgArray.push(this.$t('CargoMsg.Cargo_NotFromPreApprovalError', [errorSources]))
        } else {
          msgArray.push(this.$t('CargoMsg.Cargo_NotFromRemoteBookingError', [errorSources]))
        }
      }
      if (result.chargeStatusMap) {
        Object.entries(result.chargeStatusMap).forEach(([key, value]) => {
          // key 是主单号，value 是状态
          msgArray.push(this.$t('CargoMsg.Cargo_CostStatusAlert', [key, value]))
        })
      }
      if (msgArray && msgArray.length > 0) {
        this.$message.warning({
          dangerouslyUseHTMLString: true,
          message: `
          <div style="
            text-align: left !important;
            display: block !important;
            width: 100% !important;
          ">
            ${msgArray.join('<br>')}
          </div>`
        })
      }

      this.$emit('confirm')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-message {
  text-align: left !important;
  line-height: 1.5 !important;
  padding: 15px !important;
}

.custom-message .el-message__content {
  text-align: left !important;
  line-height: 1.5 !important;
}
</style>
